export const createOpenFlightSummary = Odigeo => () => Odigeo.trigger('flight-summary-card:clickDetails');